import api from '@pray/shared/utils/api';

import type { SeedGroupDetailResponse } from './types';

const GROUPS_URL = '/web/studio/admin/seed-emails/groups';

/**
 * One group with the ids of its live members, which is what the editor ticks.
 *
 * An unknown id answers 404 `seed_group_not_found`, and the editor turns that into a redirect back
 * to the list rather than an empty form under someone else's id.
 */
export async function getGroup(groupId: string) {
  const res = await api.executeGetRequest<{ data: SeedGroupDetailResponse }>(`${GROUPS_URL}/${groupId}`);
  return res.data.data;
}
